import angular from "angular";
import module from "../module";
import core from "../../core/core.module";

angular
    .module('accessControlCrud.moduleForm', [module, core])
    .component('moduleForm', {
        controller: ['Module', 'notifier', controller],
        template: require('./module-form.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller(Module, notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.id = null;
        $ctrl.type = null;
        $ctrl.key = null;
        $ctrl.name = null;
        $ctrl.description = null;
        $ctrl.hasPermissions = false;
        if ($ctrl.resolve.module) {
            $ctrl.id = $ctrl.resolve.module.id;
            $ctrl.type = $ctrl.resolve.module.type;
            $ctrl.key = $ctrl.resolve.module.key;
            $ctrl.name = $ctrl.resolve.module.name;
            $ctrl.description = $ctrl.resolve.module.description;
            $ctrl.hasPermissions = !!$ctrl.resolve.module.permissions.length;
        }
    };

    $ctrl.submit = function () {

        $ctrl.loading = true;

        let params = {
            type: $ctrl.type,
            key: $ctrl.key,
            name: $ctrl.name,
            description: $ctrl.description,
        };

        let defer = $ctrl.id ? Module.update($ctrl.id, params) : Module.store(params);

        defer.then(
            function (response) {
                $ctrl.loading = false;
                if (!$ctrl.id) {
                    $ctrl.id = response.data.id;
                    params.id = response.data.id;
                }
                closeModal(params);
            },
            function (error) {
                $ctrl.loading = false;
                notifier.errorResponseNotify(error);
            }
        );
    };

    function closeModal(module) {
        $ctrl.close({
            $value: {
                module: module
            }
        });
    }

    $ctrl.deleteModule = function () {
        if (!confirm('Вы действительно хотите удалить модуль?')) {
            return;
        }
        $ctrl.deleteLoading = true;
        Module.delete($ctrl.id).then(
            function () {
                $ctrl.deleteLoading = false;
                notifier.successNotify('Модуль успешно удален');
                closeModal();
            },
            function (error) {
                $ctrl.deleteLoading = false;
                notifier.errorResponseNotify(error);
            }
        );
    };
}


export default "accessControlCrud.moduleForm";


// WEBPACK FOOTER //
// ./resources/assets/modules/access-control-crud/module-form/module-form.js